import {
    Component,
    Input,
    OnInit,
    OnChanges,
    SimpleChanges,
    Output,
    EventEmitter,
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { finalize, map } from 'rxjs';
import { Generic, GenericStatusCerere } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';
import { initializeEditor } from 'src/app/utils/editorConfig';
import { helper } from 'src/environments/helper';
import {
    ICerere,
} from '../../cereri.interface';
import {
    EditRequestAssigneePayload,
    EditRequestPriorityPayload,
    EditRequestStatusPayload,
} from './actualizare-cerere.interface';
import { CereriService } from '../../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from 'src/app/services/permissions.service';
// import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-actualizare-cerere',
    templateUrl: './actualizare-cerere.component.html',
    styleUrls: ['./actualizare-cerere.component.scss'],
})
export class ActualizareCerereComponent implements OnInit, OnChanges {
    @Input() cerere!: ICerere;
    @Output() cerereChanged: EventEmitter<ICerere> = new EventEmitter<ICerere>();

    passedRequestId!: number;
    type_directie_id!: number;

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    editorConfig!: AngularEditorConfig;
    isLoading = false;
    selectedActionToggle = 'status';

    defaultChoiceParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    requestStatuses: GenericStatusCerere[] = [];
    requestPriorities: Generic[] = [];
    // compartimenteActive: any[] = [];
    compartimenteDeps: Generic[] = [];
    usersActive: Generic[] = [];

    sendUpdateAssigneeForm!: FormGroup;
    sendUpdateStatusForm!: FormGroup;
    sendUpdatePriorityForm!: FormGroup;

    constructor(
        private commonService: CommonService,
        private fb: FormBuilder,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.passedRequestId = this.cerere.id_cerere;
        this.type_directie_id = this.cerere.type_directie_id;

        if (this.cerere.cancel_type) {
            this.sendUpdateAssigneeForm.disable();
            this.sendUpdateStatusForm.disable();
            this.sendUpdatePriorityForm.disable();
        } else {
            this.sendUpdateAssigneeForm.enable();
            this.sendUpdateStatusForm.enable();
            this.sendUpdatePriorityForm.enable();
        }
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();
        this.loadRequestPriorities();
        this.loadRequestStatuses();
        this.loadCompartimente();
        /*
        Above we call load compartimente with the type_directie_id / directii/institutii with the one inside our Cerere (check in dt to see the different directii/institutii)
        The user can still select another Directie (other than Urbanism), and also other Compartimente
        */

        this.sendUpdateAssigneeForm = this.fb.group({
            //directie_id: new FormControl(-1),
            compartiment_id: new FormControl(-1),
            user_id: new FormControl(-1, [Validators.required, Validators.min(0)]),
            content: new FormControl(''),
        });
        this.sendUpdateStatusForm = this.fb.group({
            current_status: new FormControl(-1, [Validators.required, Validators.min(0)]),
            message: new FormControl(''),
        });
        this.sendUpdatePriorityForm = this.fb.group({
            id_cerere_priority: new FormControl(-1, [Validators.required, Validators.min(0)]),
            message: new FormControl(''),
        });

        if (this.cerere.cancel_type) {
            this.sendUpdateAssigneeForm.disable();
            this.sendUpdateStatusForm.disable();
            this.sendUpdatePriorityForm.disable();
        } else {
            this.sendUpdateAssigneeForm.enable();
            this.sendUpdateStatusForm.enable();
            this.sendUpdatePriorityForm.enable();
        }
    }

    loadRequestPriorities() {
        this.commonService
            .getCererePrioritiesActive()
            .pipe(map((results: any) => [this.defaultChoiceParameter, ...results]))
            .subscribe((data) => {
                this.requestPriorities = data;
            });
    }

    loadRequestStatuses() {
        this.commonService
            .getCerereStatusesActive()
            .pipe(map((results: any) => [this.defaultChoiceParameter, ...results]))
            .subscribe((data) => {
                this.requestStatuses = data;
            });
    }

    // onDirectieChange(directieId: number): void {
    //     this.isLoading = true;
    //     if (directieId) {
    //         this.loadCompartimenteActive(directieId);
    //         // this.loadUsersActive();
    //         this.loadOperatori();
    //     } else {
    //         this.compartimenteActive = [{ name: '--Alegeți--', id: -1 }];
    //         this.isLoading = false;
    //     }
    // }

    // loadCompartimenteActive(directieId?: number) {
    //     let compartimenteObservable$ = directieId
    //         ? this.commonService.getCompartimenteByDirectieId(directieId)
    //         : this.commonService.getCompartimenteActive();

    //     compartimenteObservable$
    //         .pipe(map((results: any) => [this.defaultChoiceParameter, ...results]))
    //         .subscribe((data) => {
    //             this.compartimenteActive = data;
    //             this.isLoading = false;
    //         });
    // }

    loadCompartimente() {
        this.isLoading = true;
        this.commonService
            .getCompartimenteByDeps()
            .pipe(
                map((results: any) => [this.defaultChoiceParameter, ...results]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.compartimenteDeps = results;
                },
                error: (error) => {
                    console.error('Error loading compartimente', error);
                    this.isLoading = false;
                },
            });
    }

    onDirectieCompartimentChange(compartimentId: number): void {
        this.sendUpdateAssigneeForm.controls['user_id'].patchValue(-1);
        if (compartimentId > 0) {
            // this.loadUsersActive();
            this.loadOperatori();
        } else {
            this.usersActive = [this.defaultChoiceParameter];
        }
    }


    // loadUsersActive() {
    //     this.isLoading = true;
    //     this.commonService
    //         .getUsersByOrganigrama(this.sendUpdateAssigneeForm.value)
    //         .pipe(map((results: any) => [this.defaultChoiceParameter, ...results]))
    //         .subscribe((data) => {
    //             this.usersActive = data;
    //             this.isLoading = false;
    //         });
    // }

    loadOperatori() {
        this.isLoading = true;
        this.cereriService
            .getOperatoriByCompartiment(this.sendUpdateAssigneeForm.value.compartiment_id)
            .pipe(map((results: any) => [this.defaultChoiceParameter, ...results]))
            .subscribe((data) => {
                this.usersActive = data;
                this.isLoading = false;
            });
    }

    onActionChange(event: MatButtonToggleChange) {
        this.selectedActionToggle = event.value;
    }

    submitUpdateAssigneeMessage() {
        this.isLoading = true;

        const formValues = this.sendUpdateAssigneeForm.value;

        const newRequestAssignee: EditRequestAssigneePayload = {
            ...formValues,
            id_cerere: this.cerere.id_cerere,
        };

        this.cereriService
            .updateRequestAssignee(this.cerere.id_cerere, newRequestAssignee)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.isLoading = true;
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Cerere actualizată cu succes!',
                        this.successIcon
                    );
                    this.getRequestInfo();
                    this.sendUpdateAssigneeForm.reset();
                    // this.sendUpdateAssigneeForm.patchValue({
                    //     directie_id: -1,
                    //     compartiment_id: -1,
                    //     user_id: -1,
                    //     content: '',
                    // });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    submitUpdateStatusMessage() {
        this.isLoading = true;

        const formValues = this.sendUpdateStatusForm.value;

        const newRequestStatus: EditRequestStatusPayload = {
            ...formValues,
            id_cerere: this.cerere.id_cerere,
        };

        this.cereriService
            .updateRequestStatus(this.cerere.id_cerere, newRequestStatus)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.isLoading = true;
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Cerere actualizată cu succes!',
                        this.successIcon
                    );
                    this.getRequestInfo();
                    this.sendUpdateStatusForm.reset();
                    // this.sendUpdateStatusForm.patchValue({
                    //     current_status: -1,
                    //     message: '',
                    // });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    submitUpdatePriorityMessage() {
        this.isLoading = true;

        const formValues = this.sendUpdatePriorityForm.value;

        const newRequestPriority: EditRequestPriorityPayload = {
            ...formValues,
            id_cerere: this.cerere.id_cerere,
        };

        this.cereriService
            .updateRequestPriority(this.cerere.id_cerere, newRequestPriority)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.isLoading = true;
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Cerere actualizată cu succes!',
                        this.successIcon
                    );
                    this.getRequestInfo();
                    this.sendUpdatePriorityForm.reset();
                    // this.sendUpdatePriorityForm.patchValue({
                    //     id_cerere_priority: -1,
                    //     message: '',
                    // });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    getRequestInfo() {
        this.isLoading = true;
        this.cereriService
            .getCerere(this.passedRequestId)
            .pipe(map((response: any) => response.data))
            .subscribe((requestData) => {
                this.isLoading = false;
                this.cerere = requestData;
                this.cerereChanged.emit(this.cerere);
            });
    }
}
